import ApiService from "../../utils/fetch";


const BASE_URL = process.env.REACT_APP_BASE_URL;


export const fetchAnalyticsReport = async (reportName) => {
      try {
        const response = await ApiService.get(`${BASE_URL}powerBI/embedDetails/report/${reportName}`);
        const res = response.data;
        return {
            reportId: res.reportId,
            embedUrl: res.embedUrl,
            acessToken: res.accessToken,
        };
        
      } catch (error) {
        console.error('Error fetching analytics data:', error);
      }
};

export const fetchAnalyticsReportList = async () => {
      try {
        const response = await ApiService.get(`${BASE_URL}powerBI/embedDetails/reports`);
        
        const res = response.data;
        return {
            list:res
        }
       
      } catch (error) {
        console.error('Error fetching analytics data:', error);
      }
};